angular.module('myApp.directives')
    .directive("voiceChange", function() {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude, userMediaStream, recordMediaStream, audioVideoResponse, clientTools, audioSensitivity) {
                if (clientTools.hasSupportGetUserMedia()) {
                    var questionId = $attrs.qid || $scope.audioVideoQId;
                    var canvas = $element.find('.visualizer').get(0);
                    var canvasCtx = canvas.getContext("2d");
                    var audioCtx = null;
                    var analyser = null;
                    var distortion = null;
                    var gainNode = null;
                    var biquadFilter = null;
                    var convolver = null;
                    var source = null;
                    var drawVisual = null;

                    var reset = function() {
                        if (audioCtx) {
                            audioCtx.close();
                        }
                        audioCtx = null;
                        drawVisual = null;
                        analyser = null;
                        distortion = null;
                        gainNode = null;
                        biquadFilter = null;
                        convolver = null;
                        stopDoingAudioCheck();
                    };
                    var initialization = function() {
                        reset();
                        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                        source = null;
                        analyser = audioCtx.createAnalyser();
                        analyser.minDecibels = -70;
                        analyser.maxDecibels = -10;
                        analyser.smoothingTimeConstant = 0.85;
                        analyser.countCalls = 0;

                        distortion = audioCtx.createWaveShaper();
                        gainNode = audioCtx.createGain();
                        biquadFilter = audioCtx.createBiquadFilter();
                        convolver = audioCtx.createConvolver();
                    };
                    var checkInterval               = audioSensitivity.getStartDoingCheckAfterSeconds();
                    var timer                       = {};
                    var maxAudioLevelBuffer         = [];
                    var audioLevelCheckFrequency    = 10;
                    var startDoingAudioCheck = function () {
                        var recordingStatus = recordMediaStream.getRecordingStatus(questionId);
                        if (!(questionId in timer) && audioSensitivity.isDoAudioCheck(questionId) && recordingStatus == audioVideoResponse.recordActive) {
                            var t = setTimeout(function () {
                                clearTimeout(t);
                                timer[questionId] = setInterval(function () {
                                    if (!audioSensitivity.isDoAudioCheck(questionId)) {
                                        stopDoingAudioCheck();
                                    } else if (maxAudioLevelBuffer.length) {
                                        var sum = 0;
                                        for (var i = 0; i < maxAudioLevelBuffer.length; i++) {
                                            sum += maxAudioLevelBuffer[i];
                                        }
                                        audioSensitivity.checkCurrentAudioLevel(questionId, sum/maxAudioLevelBuffer.length);
                                        maxAudioLevelBuffer = [];
                                    }
                                }, checkInterval);
                            }, checkInterval);
                        }
                    };
                    var stopDoingAudioCheck = function () {
                        if (questionId in timer) {
                            maxAudioLevelBuffer = [];
                            clearInterval(timer[questionId]);
                            delete timer[questionId];
                        }
                    };
                    var visualize = function () {
                        var WIDTH = canvas.width;
                        var HEIGHT = canvas.height;
                        analyser.fftSize = 256;
                        var bufferLength = analyser.frequencyBinCount;
                        var dataArray = new Uint8Array(bufferLength);
                        canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);
                        canvasCtx.globalAlpha = 1;
                        var draw = function () {
                            if (analyser) {
                                drawVisual = requestAnimationFrame(draw);
                                analyser.getByteFrequencyData(dataArray);
                                canvasCtx.fillStyle = $attrs.fill;
                                canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);
                                var barWidth = (WIDTH / bufferLength) * 2.5;
                                var barHeight;
                                var x = 0;
                                for (var i = 0; i < bufferLength; i++) {
                                    barHeight = dataArray[i];
                                    canvasCtx.fillStyle = 'rgb(' + (/*barHeight+*/51) + ',91,90)';
                                    canvasCtx.fillRect(x, HEIGHT - barHeight / 2, barWidth, barHeight / 2);
                                    x += barWidth + 1;
                                }
                                analyser.countCalls++;
                                if ((questionId in timer) && analyser.countCalls % audioLevelCheckFrequency == 0 && audioSensitivity.isDoAudioCheck(questionId)) {
                                    maxAudioLevelBuffer.push(Math.max.apply(Math, dataArray));
                                }
                            }
                        };
                        draw();
                    };
                    var voiceChange = function () {
                        distortion.oversample = '4x';
                        biquadFilter.gain.value = 0;
                        convolver.buffer = null;
                    };

                    $scope.$on("userMediaStreamAdded", function (e, data) {
                        if (data && data.qId == questionId) {
                            var stream = userMediaStream.getStream(questionId);
                            if (stream) {
                                initialization();
                                try {
                                    source = audioCtx.createMediaStreamSource(stream);
                                    source.connect(analyser);
                                    analyser.connect(distortion);
                                    distortion.connect(biquadFilter);
                                    biquadFilter.connect(convolver);
                                    convolver.connect(gainNode);
                                    gainNode.connect(audioCtx.destination);
                                    visualize();
                                    voiceChange();
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        }
                    });
                    $scope.$on("recordingStatusChanged", function (e, data) {
                        if (data && ('qId' in data) && data.qId == questionId) {
                            var recordingStatus = recordMediaStream.getRecordingStatus(questionId);
                            if (recordingStatus == audioVideoResponse.recordStopped) {
                                reset();
                            } else if (recordingStatus == audioVideoResponse.recordActive) {
                                startDoingAudioCheck();
                            } else if (recordingStatus == audioVideoResponse.recordPaused) {
                                stopDoingAudioCheck();
                            }
                        }
                    });
                    $scope.$on("$destroy", function() {
                        reset();
                    });
                }
            }
        }
    });